@if (config && config.heroConfig) {
    <sirius-hero-small [config]="config.heroConfig">
        @if (config.countdown) {
            <ur-countdown [config]="config.countdown"></ur-countdown>
        }
    </sirius-hero-small>
}
